// Internal modules
import type {
  SuggestedDefaultLanguagesQueryQuery,
  SuggestedDefaultLanguagesQueryQueryVariables,
} from '@/generated/graphql';
import { apolloClient } from '@/lib/apollo';
import { getLocale } from '@/lib/globals';
import { SUGGESTED_DEFAULT_LANGUAGES_QUERY } from '../queries';

/**
 * For the suggested default language query we reuse the initial
 * language and country to ensure that the data is in the Apollo cache. The
 * two fields we need from that query, country code and language code, aren't
 * dependent on the country or language so using the initial values is fine.
 */
const { country: INITIAL_COUNTRY, language: INITIAL_LANGUAGE } = getLocale();

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const readSuggestedLanguagesQuery = () => {
  // eslint-disable-next-line max-len
  // Promise<Pick<LocaleTerritoryMetadata, 'code' | 'suggestedDefaultLanguage'>[]>
  const queryResult = apolloClient.readQuery<
    SuggestedDefaultLanguagesQueryQuery,
    SuggestedDefaultLanguagesQueryQueryVariables
  >({
    query: SUGGESTED_DEFAULT_LANGUAGES_QUERY,
    variables: {
      countryCode: INITIAL_COUNTRY,
      // @ts-expect-error Type globals languageCode
      languageCode: INITIAL_LANGUAGE,
    },
  });

  /**
   * The suggestedDefaultLanguage is a field on the objects in the territories
   * array. E.G.
   *  [
   *    { code: 'FR', suggestedDefaultLanguage: 'fr' },
   *    { code: 'FR', suggestedDefaultLanguage: 'fr' },
   *    { code: 'US', suggestedDefaultLanguage: 'en' },
   *    etc...
   *  ]
   */
  return queryResult?.localeMetadata?.territories;
};
